import React from 'react';
import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-background pt-24 pb-12 border-t border-border" data-id="element-72">
      <div className="container mx-auto px-6 md:px-12" data-id="element-73">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16" data-id="element-74">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-75">
            <a href="#" className="flex flex-col items-start mb-6" data-id="element-76">
              <span className="font-serif text-3xl text-foreground tracking-widest leading-none" data-id="element-77">
                LIBELLE
              </span>
              <span className="text-[0.65rem] uppercase tracking-[0.3em] text-gold mt-1" data-id="element-78">
                Estética
              </span>
            </a>
            <p className="text-muted-foreground font-light text-sm leading-relaxed mb-6" data-id="element-79">
              Clínica de medicina estética premium dedicada a realzar tu belleza
              natural con la tecnología más avanzada y un equipo médico de
              excelencia.
            </p>
            <div className="flex gap-4" data-id="element-80">
              <a href="#" className="w-10 h-10 rounded-full border border-border flex items-center justify-center text-foreground hover:text-gold hover:border-gold transition-colors" data-id="element-81">
                <Instagram className="w-4 h-4" data-id="element-82" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-border flex items-center justify-center text-foreground hover:text-gold hover:border-gold transition-colors" data-id="element-83">
                <Facebook className="w-4 h-4" data-id="element-84" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-85">
            <h4 className="font-serif text-xl text-foreground mb-6" data-id="element-86">Enlaces</h4>
            <ul className="space-y-4" data-id="element-87">
              {['Tratamientos Faciales', 'Tratamientos Corporales', 'Tecnología Láser', 'Nuestro Equipo', 'Testimonios'].map((link, i) => <li key={i} data-id="element-88">
                  <a href="#" className="text-muted-foreground hover:text-gold transition-colors text-sm font-light" data-id="element-89">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-90">
            <h4 className="font-serif text-xl text-foreground mb-6" data-id="element-91">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-92">
              <li className="flex items-start gap-3 text-muted-foreground text-sm font-light" data-id="element-93">
                <MapPin className="w-5 h-5 text-gold flex-shrink-0" data-id="element-94" />
                <span data-id="element-95">
                  Avenida Cabildo 1370
                  <br data-id="element-96" />
                  Buenos Aires, Argentina
                </span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm font-light" data-id="element-97">
                <Phone className="w-5 h-5 text-gold flex-shrink-0" data-id="element-98" />
                <span data-id="element-99">+54 11 4000 0000</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm font-light" data-id="element-100">
                <Mail className="w-5 h-5 text-gold flex-shrink-0" data-id="element-101" />
                <span data-id="element-102">contacto@libelleestetica.com</span>
              </li>
            </ul>
          </div>

          {/* Schedule */}
          <div data-id="element-103">
            <h4 className="font-serif text-xl text-foreground mb-6" data-id="element-104">Horario</h4>
            <ul className="space-y-4 text-sm font-light text-muted-foreground" data-id="element-105">
              <li className="flex justify-between border-b border-border pb-2" data-id="element-106">
                <span data-id="element-107">Lunes - Viernes</span>
                <span data-id="element-108">10:00 - 20:00</span>
              </li>
              <li className="flex justify-between border-b border-border pb-2" data-id="element-109">
                <span data-id="element-110">Sábados</span>
                <span data-id="element-111">10:00 - 14:00</span>
              </li>
              <li className="flex justify-between text-gold" data-id="element-112">
                <span data-id="element-113">Domingos</span>
                <span data-id="element-114">Cerrado</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground font-light" data-id="element-115">
          <p data-id="element-116">
            &copy; {new Date().getFullYear()} Libelle Estética. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-4" data-id="element-117">
            <a href="#" className="hover:text-gold transition-colors" data-id="element-118">
              Aviso Legal
            </a>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-119">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-120">
              Política de Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>;
}